export const categories = [
  {
    slug: 'training-moves',
    name: '训练动作',
    description: '精选最有效的蜜桃臀训练动作，从基础激活到高阶强化，手把手教你练出完美翘臀曲线。',
    icon: 'ri-run-line',
    image: 'https://readdy.ai/api/search-image?query=Fit%20woman%20doing%20hip%20thrust%20exercise%20in%20a%20bright%20modern%20home%20gym%20with%20yoga%20mat%20and%20dumbbells%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20warm%20neutral%20tones%2C%20fitness%20lifestyle%20photography%2C%20high%20detail%2C%20professional%20composition%20with%20shallow%20depth%20of%20field&width=800&height=600&seq=cat-training-01&orientation=landscape',
    articleCount: 12,
  },
  {
    slug: 'diet-nutrition',
    name: '饮食营养',
    description: '科学的饮食搭配方案，为臀部增肌提供充足营养支持，吃对才能练好。',
    icon: 'ri-restaurant-line',
    image: 'https://readdy.ai/api/search-image?query=Healthy%20balanced%20meal%20bowl%20with%20protein%20rich%20foods%20like%20grilled%20chicken%20avocado%20quinoa%20and%20fresh%20vegetables%20on%20a%20marble%20countertop%2C%20soft%20warm%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20warm%20neutral%20tones%2C%20food%20photography%20style%2C%20high%20detail%2C%20professional%20composition&width=800&height=600&seq=cat-diet-01&orientation=landscape',
    articleCount: 8,
  },
  {
    slug: 'common-myths',
    name: '常见误区',
    description: '揭秘臀部训练的流行谣言与错误认知，帮你避开弯路，训练更高效。',
    icon: 'ri-lightbulb-line',
    image: 'https://readdy.ai/api/search-image?query=Fitness%20studio%20with%20a%20woman%20trainer%20explaining%20correct%20exercise%20form%20to%20a%20client%20near%20mirror%20wall%2C%20bright%20clean%20space%2C%20soft%20warm%20lighting%2C%20minimalist%20aesthetic%2C%20warm%20neutral%20tones%2C%20professional%20fitness%20photography%2C%20high%20detail%2C%20natural%20composition&width=800&height=600&seq=cat-myths-01&orientation=landscape',
    articleCount: 6,
  },
  {
    slug: 'home-training',
    name: '居家训练',
    description: '无需器械或仅需简单工具，在家也能高效练出蜜桃臀，适合忙碌的都市女性。',
    icon: 'ri-home-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Woman%20doing%20glute%20bridge%20exercise%20at%20home%20in%20a%20cozy%20living%20room%20with%20yoga%20mat%20and%20resistance%20bands%2C%20soft%20natural%20light%20from%20window%2C%20minimalist%20home%20decor%2C%20warm%20neutral%20tones%2C%20lifestyle%20fitness%20photography%2C%20high%20detail%2C%20calm%20atmosphere&width=800&height=600&seq=cat-home-01&orientation=landscape',
    articleCount: 10,
  },
  {
    slug: 'gym-training',
    name: '健身房训练',
    description: '充分利用健身房器械，设计进阶臀部训练方案，突破平台期持续进步。',
    icon: 'ri-building-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20fitness%20gym%20with%20a%20woman%20using%20cable%20machine%20for%20glute%20kickback%20exercise%2C%20clean%20well%20equipped%20space%2C%20soft%20warm%20lighting%2C%20minimalist%20aesthetic%2C%20warm%20neutral%20tones%2C%20professional%20gym%20photography%2C%20high%20detail%2C%20dynamic%20composition&width=800&height=600&seq=cat-gym-01&orientation=landscape',
    articleCount: 9,
  },
  {
    slug: 'muscle-activation',
    name: '肌肉激活',
    description: '学习正确的臀部肌肉激活方法，建立神经肌肉连接，让每一次训练都精准有效。',
    icon: 'ri-flashlight-line',
    image: 'https://readdy.ai/api/search-image?query=Woman%20doing%20clamshell%20exercise%20on%20yoga%20mat%20in%20a%20bright%20airy%20studio%2C%20focusing%20on%20glute%20activation%2C%20soft%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20warm%20neutral%20tones%2C%20fitness%20photography%2C%20high%20detail%2C%20mindful%20composition&width=800&height=600&seq=cat-activation-01&orientation=landscape',
    articleCount: 7,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});